import React, { useEffect, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import { getAllImages } from "../_api";
import "../Assets/css/table.css";
import "../Assets/css/pagination.css";
import "../Assets/css/custom.css";
import { ExportCSV } from "../components/ExportCSV";
import { photoboothName } from "../utils/fixers";
import Loader from "../components/Loader";

export default function List() {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [error, setError] = useState(null);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [csvData, setCsvData] = useState([]);
  const [sNo, setSNo] = useState(1);
  const [previewImage, setPreviewImage] = useState(null);

  const tableRef = useRef(null);

  useEffect(() => {
    setCsvData(() =>
      images.map((item, index) => ({
        "S.No.": index + 1 + (page - 1) * 40,
        "Image Url": item,
      }))
    );
    setSNo((page - 1) * 40 + 1);
  }, [images]); // eslint-disable-line

  useEffect(() => {
    getAllImages({
      scrollToTop,
      setImages,
      setLoading,
      setError,
      setCount,
      page,
    });
  }, [page]);

  useEffect(() => {
    document.title = "List";
    window.addEventListener("mousemove", ({ target }) => {
      if (target.id.includes("http")) setPreviewImage(target.id);
      else setPreviewImage(null);
    });
  }, []);

  const scrollToTop = () => (tableRef.current.scrollTop = 0);

  const GetTableData = () =>
    images.map((url, key) => (
      <tr key={key}>
        <td>{key + sNo}</td>
        <td>
          <span
            className="link"
            onClick={() => window.open(url, "_blank", "noreferrer")}
          >
            {url}
          </span>
        </td>
        <td>
          <img id={url} alt={`pic-${key + 1}`} src={url} />{" "}
        </td>
      </tr>
    ));

  return (
    <>
      <div
        ref={tableRef}
        className={`table-container${!images.length ? " d-none" : ""}`}
      >
        <div className="thead">
          <span>S.No.</span>
          <span>Image Url</span>
          <span>Preview</span>
        </div>
        <table className="rwd-table">
          <tbody>
            <GetTableData />
          </tbody>
        </table>
        <div className="export-btn">
          <ExportCSV csvData={csvData} fileName={photoboothName} />
        </div>
        <ReactPaginate
          activeClassName={"item active "}
          breakClassName={"item break-me "}
          breakLabel={"..."}
          containerClassName={"pagination"}
          disabledClassName={"disabled-page"}
          marginPagesDisplayed={2}
          nextClassName={"item next "}
          nextLabel={"Next"}
          onPageChange={({ selected }) => setPage(selected + 1)}
          pageCount={Math.floor(count / 40) + 1}
          pageClassName={"item pagination-page "}
          pageRangeDisplayed={2}
          previousClassName={"item previous"}
          previousLabel={"Previous"}
        />
        {error && <div className="network-err"> Please Check Your Network</div>}
        {previewImage && (
          <div className="img-preview">
            {" "}
            <img alt="img-preview" src={previewImage} />
          </div>
        )}
      </div>
      {loading && <Loader />}
      <div id="warning">Screen is too small to view the content</div>
    </>
  );
}
